module.exports = __webpack_public_path__ + "img/flex-contrology.d5452411.svg";